// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carousel .thumb.selected {\n    border: 3px solid #057FAF;\n}\n\n.carousel .thumb:hover{\n    border: 3px solid #057FAF;\n}\n\n.carousel .slide {\n\n    background: rgba(0,0,0,0);\n}", ""]);
// Exports
module.exports = exports;
